import { render, staticRenderFns } from "./CustomMenuDemo.vue?vue&type=template&id=1ed8d1c2&scoped=true"
import script from "./CustomMenuDemo.vue?vue&type=script&lang=js"
export * from "./CustomMenuDemo.vue?vue&type=script&lang=js"
import style0 from "./CustomMenuDemo.vue?vue&type=style&index=0&id=1ed8d1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8d1c2",
  null
  
)

export default component.exports